// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cf00a6e9","796":"3d5a25d9","966":"1edccc68"}[chunkId] + ".chunk.js";
};